import { Layout } from '@components/Layout';
import { useGetDashboardNewApplications } from '@hooks/useGetDashboardNewApplications';
import { useGetDashboardNewCompanies } from '@hooks/useGetDashboardNewCompanies';
import { useGetDashboardNewJobOffers } from '@hooks/useGetDashboardNewJobOffers';
import { useGetDashboardNewTalents } from '@hooks/useGetDashboardNewTalents';
import { useGetDashboardStats } from '@hooks/useGetDashboardStats';
import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { AnalyticsCard } from './AnalyticsCard';
import { DateNavigation } from './DateNavigation';
import { NewCompanies } from './NewCompanies';
import { NewJobApplications } from './NewJobApplications';
import { NewJobOffers } from './NewJobOffers';
import { NewTalents } from './NewTalents';

export const HomePage = () => {
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const navigate = useNavigate();

    const { stats } = useGetDashboardStats(selectedDate);
    const { talents, loading: talentsLoading } = useGetDashboardNewTalents(selectedDate);
    const { companies, loading: companiesLoading } = useGetDashboardNewCompanies(selectedDate);
    const { jobOffers: classicOffers, loading: classicOffersLoading } = useGetDashboardNewJobOffers(selectedDate, 'direct_email');
    const { jobOffers: premiumOffers, loading: premiumOffersLoading } = useGetDashboardNewJobOffers(selectedDate, 'premium');
    const { applications: classicApplications, loading: classicAppsLoading } = useGetDashboardNewApplications(selectedDate, 'direct_email');
    const { applications: premiumApplications, loading: premiumAppsLoading } = useGetDashboardNewApplications(selectedDate, 'premium');

    return (
        <Layout breadcrumbs={[{ label: 'Tableau de bord', href: '' }]} heading="Tableau de bord">
            <Box>
                <DateNavigation
                    onDateChange={(date) => {
                        setSelectedDate(date);
                    }}
                />
                <Grid container spacing={3} alignItems="stretch">
                    {/* Analytics Card */}
                    {/* {stats && (
                        <Grid item xs={12}>
                            <AnalyticsCard
                                companiesToday={stats.companiesToday}
                                companiesTotal={stats.companiesTotal}
                                talentsToday={stats.talentsToday}
                                talentsTotal={stats.talentsTotal}
                                jobOffersToday={stats.jobOffersToday}
                                jobOffersTotal={stats.jobOffersTotal}
                                applicationsToday={stats.applicationsToday}
                                applicationsTotal={stats.applicationsTotal}
                                offerBreakdown={stats.offerBreakdown}
                                applicationBreakdown={stats.applicationBreakdown}
                            />
                        </Grid>
                    )} */}

                    {/* New Talents Card */}
                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewTalents
                            talents={talents}
                            loading={talentsLoading}
                            onViewAll={() => navigate('/talents')}
                        />
                    </Grid>

                    {/* New Companies Card */}
                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewCompanies
                            companies={companies}
                            loading={companiesLoading}
                            onViewAll={() => navigate('/companies')}
                        />
                    </Grid>

                    {/* New Job Applications Cards */}
                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewJobApplications
                            applications={classicApplications}
                            loading={classicAppsLoading}
                            title="Nouvelles Candidatures Classique"
                            count={stats?.applicationsToday ?? 0}
                            onViewAll={() => navigate('/applications')}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewJobApplications
                            applications={premiumApplications}
                            loading={premiumAppsLoading}
                            title="Nouvelles Candidatures Premium"
                            count={stats?.applicationsToday ?? 0}
                            onViewAll={() => navigate('/applications')}
                        />
                    </Grid>

                    {/* New Job Offers Cards */}
                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewJobOffers
                            offers={classicOffers}
                            loading={classicOffersLoading}
                            title="Nouvelles Offres d'emploi Classique"
                            count={stats?.jobOffersToday ?? 0}
                            onViewAll={() => navigate('/job-offers')}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <NewJobOffers
                            offers={premiumOffers}
                            loading={premiumOffersLoading}
                            title="Nouvelles Offres d'emploi Premium"
                            count={stats?.jobOffersToday ?? 0}
                            onViewAll={() => navigate('/job-offers')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Layout>
    );
};
